// ThreadForm
import ClassNames from 'classnames';
import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import { getTranslator } from '../locales';
import { insiderFormSubmit } from '../redux/actions/insidersAction';

@connect((Store) => {
  const t = getTranslator();

  return {
    labels: {
      NOTIFICATION: t.t('NOTIFICATION'),
      CANCEL: t.t('Cancel'),
      POST_A_MESSAGE_TO_EVERYONE: t.t('Post a message to everyone'),
      SEND_MY_ALERT: t.t('Send my alert'),
      THIS_WILL_BE_PROMPT_TO_X_PEOPLE_ONLINE: t.t('This will be shown to all people online'),
      WRITE_YOUR_FULL_MESSAGE_HERE: t.t('Type your full message here...')
    },
    luser: Store.luser,
    connectedUsersCount: Store.chat.connectedUsersCount,
    isNotificationFormOpened: Store.chat.isNotificationFormOpened,
    selectedThread: Store.threads.selectedThread
  };
})

export default class InsiderNotificationForm extends React.Component {
  constructor() {
    super();
    this.state = { message: '' };
  }

  changeHandler(e) {
    const stateObject = function() {
      const returnObj = {};
      returnObj[this.target.name] = _.replace(
        _.upperFirst(_.trimStart(this.target.value)),
        /\n{2,}/ig,
        '\n\n'
      );

      return returnObj;
    }.bind(e)();

    this.setState(stateObject);
  }

  handleSubmit(e) {
    e.preventDefault();
    const message = _.replace(
      _.upperFirst(_.trimStart(this.state.message)),
      /\n{2,}/ig,
      '\n\n'
    );

    if (message == '') {
      return;
    }

    const notification = { message };
    this.setState({ message: '' });

    this.props.dispatch(insiderFormSubmit(notification));
    this.props.mobilePanelChange('messages');
  }

  handdleToggleForm(e) {
    e.preventDefault();
    if (this.props.selectedThread && this.props.selectedThread.id) {
      this.props.mobilePanelChange('messages');
    } else {
      this.props.mobilePanelChange('welcomehelper');
    }
  }

  render() {
    // isNotificationFormOpened ?
    let itemClass = {
      // 'insider_form': true,
      'shown': this.props.isNotificationFormOpened
    };

    itemClass[ this.props.mobilePanelClassName('insider_form') ] = true;
    itemClass = ClassNames(itemClass);

    return (
      <div className={itemClass}>
        <div className='heading brandedColor_bg'>
          <i className='pe-7s-speaker'></i>
          <h2> {this.props.labels.NOTIFICATION} — {this.props.labels.POST_A_MESSAGE_TO_EVERYONE}</h2>
          <div className='clear'></div>
        </div>
        <div className='inner-content'>
          <form onSubmit={this.handleSubmit.bind(this)}>
            <h4 className='brandedColor_color'>
              <i className="pe-7s-attention"></i>
              {this.props.labels.THIS_WILL_BE_PROMPT_TO_X_PEOPLE_ONLINE} ({this.props.connectedUsersCount})
            </h4>
            <div className="form-group">
              <textarea
                id='notification'
                name='message'
                onChange={this.changeHandler.bind(this)}
                value={this.state.message}
                className="form-control"
                placeholder={this.props.labels.WRITE_YOUR_FULL_MESSAGE_HERE}
                required="required"
                autoFocus={true}
              ></textarea>
            </div>
            <div className='actions'>
              <button className='btn btn-secondary fleft' onClick={this.handdleToggleForm.bind(this)}>{this.props.labels.CANCEL}</button>
              <input type="submit" value={this.props.labels.SEND_MY_ALERT} className="btn btn-primary brandedColor_bg brandedColorLight_border" />
            </div>
          </form>
          <div className="clear"></div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/InsiderNotificationForm.jsx